import { render, staticRenderFns } from "./ProcessModel.vue?vue&type=template&id=6166e89e&"
import script from "./ProcessModel.vue?vue&type=script&lang=js&"
export * from "./ProcessModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports